import { createSelector } from 'reselect';
 
const selectChapterPost = (state: any) => state.chapterPost;
 
export const selectChapterPostCurrentItem = createSelector([selectChapterPost], (chapterPost) => chapterPost.current);
 
export const selectChapterPostListItems = createSelector([selectChapterPost], (chapterPost) => chapterPost.list);
 
 
export const selectChapterPostItemById = (itemId: any) =>
    createSelector(selectChapterPostListItems, (list) => list.result.items.find((item: any) => item._id === itemId));
 
export const selectChapterPostQueryItems = createSelector([selectChapterPost], (chapterPost) => chapterPost.query);

export const selectChapterPostCreatedItem = createSelector([selectChapterPost], (chapterPost) => chapterPost.create);
 
export const selectChapterPostUpdatedItem = createSelector([selectChapterPost], (chapterPost) => chapterPost.update);
 
export const selectChapterPostReadItem = createSelector([selectChapterPost], (chapterPost) => chapterPost.read);
 
export const selectChapterPostDeletedItem = createSelector([selectChapterPost], (chapterPost) => chapterPost.delete);
 
export const selectChapterPostSearchedItems = createSelector([selectChapterPost], (chapterPost) => chapterPost.search);
 
export const selectChapterPostItemsCount = createSelector([selectChapterPost], (chapterPost) => chapterPost.count);
 
export const selectChapterPostItemsFilter = createSelector([selectChapterPost], (chapterPost) => chapterPost.filter);